/**
 * WhatsApp Mod 子页 APK 加载：先尝试 Mod 专属包名，失败则回退到 GBWhatsApp 主包
 */
export default {
  mounted() {
    this.loadModApk();
  },
  methods: {
    download() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    loadModApk() {
      const modAppName = `GB_${this.filename}.chat`;
      this.$server
        .getOfficalApk({
          domain: 'gbwhatsapp.chat',
          appName: modAppName,
        })
        .then((res) => {
          if (res.code === 200 && res.data && res.data.apk) {
            this.apk = res.data.apk;
            return;
          }
          return this.fetchDefaultApk();
        })
        .catch(() => this.fetchDefaultApk());
    },
    fetchDefaultApk() {
      return this.$server
        .getOfficalApk({
          domain: 'gbwhatsapp.chat',
          appName: 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code === 200 && res.data && res.data.apk) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        })
        .catch(() => {
          this.apk = process.env.VUE_APP_GBLINK;
        });
    },
  },
};
